import { stringify } from "qs";
import request from "../../request";
import { url } from "../../service-utils";
import { GetQueryString } from "../../utils";

// 局端
// 学生榜单
// 班级榜单
export async function bureauStuClassRank(params) {
  return request(
    `${url.activitySign}/leaderboard/edu-dept-stu-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 个人榜单
export async function bureauStuPersonalRank(params) {
  return request(
    `${url.activitySign}/leaderboard/edu-person-stu-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 学校榜单
export async function bureauStuSchoolRank(params) {
  return request(
    `${url.activitySign}/leaderboard/edu-school-stu-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 教师榜单
// 个人榜单
export async function bureauTeaPersonalRank(params) {
  return request(
    `${url.activitySign}/leaderboard/edu-person-tea-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 学校榜单
export async function bureauTeaSchoolRank(params) {
  return request(
    `${url.activitySign}/leaderboard/edu-school-tea-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 校端
// 学生榜单
// 班级榜单
export async function schoolStuClassRank(params) {
  return request(
    `${url.activitySign}/leaderboard/school-dept-stu-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 个人榜单
export async function schoolStuPersonalRank(params) {
  return request(
    `${url.activitySign}/leaderboard/school-person-stu-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 学校榜单
export async function schoolStuSchoolRank(params) {
  return request(
    `${url.activitySign}/leaderboard/school-school-stu-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}

// 教师榜单
// 个人榜单
export async function schoolTeaPersonalRank(params) {
  return request(
    `${url.activitySign}/leaderboard/school-person-tea-p?${stringify({
      ...params,
      appId: GetQueryString("appId") || 40
    })}`
  );
}
